// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5a-1";
export var standaloneTable = "_5a-0";